'use client'

import AppleLogo from '@/assets/images/AppleLogo.svg'
import { useTranslation } from 'react-i18next'
import Image from 'next/image'
import Link from 'next/link'
import { APPSTORE_LINK, GOOGLEPLAY_LINK } from '@/constants/links'
import { GA_EVENTS } from '@/utils/analytics'

const Footer = () => {
  const { t } = useTranslation('home')

  const handleFooterDownload = (platform: 'ios' | 'android') => {
    GA_EVENTS.DOWNLOAD_START(platform)
    GA_EVENTS.BUTTON_CLICK(`footer_${platform}_download`)
  }

  const handleLinkClick = (linkName: string) => {
    GA_EVENTS.LINK_CLICK(linkName, `/${linkName}`)
  }

  return (
    <footer className="w-full bg-surface-light dark:bg-surface-dark flex justify-center py-20">
      <div className="max-w-[1440px] w-full px-5 sm:px-[156px] flex flex-col justify-center gap-4">
        <h2 className="font-pretendard-bold text-[15px] text-pure-black dark:text-pure-white text-opacity-85">
          {t('footer_title')}
        </h2>
        <div>
          <div className="flex sm:flex-row flex-col sm:gap-6 mb-0.5">
            <p className="font-pretendard-regular text-[13px] text-main-light-1 dark:text-main-dark-1">
              {t('business_registration_number')} : 713-81-04023 | {t('representative')} : 강종엽
            </p>
            {/* <p className="font-pretendard-regular text-[13px] text-main-light-1 dark:text-main-dark-1">
              {t('online_business_report')} : 제2024-안양동안-0401호
            </p> */}
          </div>
          <div className="flex sm:flex-row flex-col sm:gap-6 mb-0.5">
            <p className="font-pretendard-regular text-[13px] text-main-light-1 dark:text-main-dark-1">
              {t('address')} : 경기도 안양시 동안구 부림로 113, 2109호(관양동, 평촌아이파크)
            </p>
          </div>
          <div className="flex sm:flex-row flex-col sm:gap-6 mb-0.5">
            <p className="font-pretendard-regular text-[13px] text-main-light-1 dark:text-main-dark-1">
              {t('contact_number')} : <a href="tel:070-7954-2342">070-7954-2342</a>
            </p>
          </div>
          <div className="flex sm:flex-row flex-col sm:gap-6 mb-0.5">
            <p className="font-pretendard-regular text-[13px] text-main-light-1 dark:text-main-dark-1">
              {t('inquiries')} : <a href="mailto:love@fanhearts.com">love@fanhearts.com</a>
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <Link
              href={'/terms'}
              className="font-pretendard-regular text-[13px] text-main-light-1 dark:text-main-dark-1"
              onClick={() => handleLinkClick('terms')}
            >
              {t('terms')}
            </Link>
            <div className="border-l-[1px] border-gray-400 h-2.5"></div>
            <Link
              href={'/terms?tab=privacy_policy'}
              className="font-pretendard-regular text-[13px] text-main-light-1 dark:text-main-dark-1"
              onClick={() => handleLinkClick('/terms?tab=privacy_policy')}
            >
              {t('policy')}
            </Link>
          </div>
        </div>
        <div className="flex gap-2">
          <Link href={APPSTORE_LINK} onClick={() => handleFooterDownload('ios')}>
            <AppleLogo />
          </Link>
          <Link href={GOOGLEPLAY_LINK} onClick={() => handleFooterDownload('android')}>
            <div className="w-[35px] h-[35px] flex items-center justify-center rounded-full bg-theme-light-gray-200">
              <Image
                src={'/images/Google.svg'}
                alt="google-logo"
                width={18}
                height={18}
              />
            </div>
          </Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
